<script>
  import { Route, router, meta } from "tinro";
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import {
    currentPage,
    skillId,
    cid,
    userId,
    userName,
    assessmentType,
    assessmentId,
    assessmentState,
    instanceId,
    exerciseId,
    domain,
    invitationNumber,
    readinessCheckCompleted,
    activationCode,
  } from "./utilities/DataStore";

  import AssessmentOverview from "./assessment/AssessmentOverview.svelte";
  import InitPage from "./assessment/InitPage.svelte";

  import TopHeaderComponent from "./utilities/TopHeaderComponent.svelte";
  import AssessmentExercise from "./assessment/AssessmentExercise.svelte";
  import AssessmentResults from "./assessment/AssessmentResults.svelte";
  import IntroductionPage from "./assessment/IntroductionPage.svelte";
  import LandingPage from "./assessment/LandingPage.svelte";
  import LandingPage104Demo from "./assessment/LandingPage104Demo.svelte";
  import LandingPageFree from "./assessment/LandingPageFree.svelte";
  import { addMessages, init, getLocaleFromNavigator } from "svelte-i18n";

  import en from "./i18n/en.json";
  import zhTW from "./i18n/zh-TW.json";
  import PreviousExamPage from "./assessment/PreviousExamPage.svelte";
  import AssessmentSelection from "./assessment/AssessmentSelection.svelte";
  import LandingPageNtnu from "./assessment/LandingPageNtnu.svelte";
  import LandingPageWhitelabel from "./assessment/LandingPageWhitelabel.svelte";
  import LandingPageLiteon from "./assessment/LandingPageLiteon.svelte";
  import LandingPageGeneric from "./assessment/LandingPageGeneric.svelte";
  import LandingPageGjun from "./assessment/LandingPageGjun.svelte";
  import AssessmentInvitationReport from "./assessment/AssessmentInvitationReport.svelte";
  import { BASE_URL } from "./utilities/config.js";

  addMessages("en", en);
  addMessages("zh-TW", zhTW);

  router.mode.hash();

  console.log("getLocaleFromNavigator", getLocaleFromNavigator());
  init({
    fallbackLocale: "en",
    initialLocale: getLocaleFromNavigator(),
  });

  onMount(async () => {
    initParamsFromUrl();
  });

  function initParamsFromUrl() {
    const url_string = window.location.href;

    const domainValue = window.location.hostname;
    $domain = domainValue;
    console.log("domain", $domain);

    const url = new URL(url_string);
    if (url.hash.startsWith("#/certificate/")) {
      const parts = url.hash.split("/");
      $instanceId = parts[parts.length - 1];
      $currentPage = "AssessmentResults";
      console.log("Open certificate");
      return;
    }

    $userId = url.searchParams.get("userId");
    $userName = url.searchParams.get("userName");
    $assessmentType = url.searchParams.get("assessmentType");
    $assessmentId = url.searchParams.get("assessmentId");
    $skillId = url.searchParams.get("skillId");
    $cid = url.searchParams.get("cid");
    url.searchParams.delete("userId");
    url.searchParams.delete("userName");
    url.searchParams.delete("assessmentType");
    url.searchParams.delete("assessmentId");
    url.searchParams.delete("skillId");
    url.searchParams.delete("cid");

    console.log("userId", $userId);
    console.log("userName", $userName);
    console.log("assessmentType", $assessmentType);
    console.log("assessmentId", $assessmentId);

    if ($assessmentId && $userId && $assessmentType && $skillId && $cid) {
      //router.goto("/assessment/" + $assessmentId);
      $currentPage = "Landing";
    }

    if (url.hash.startsWith("#/progress/")) {
      const parts = url.hash.split("/");
      $instanceId = parts[parts.length - 2];
      $exerciseId = parts[parts.length - 1];

      console.log("Open Progress", $exerciseId, $instanceId);
      if ($exerciseId && $instanceId) {
        //router.goto("/assessment/" + $assessmentId);
        $currentPage = "AssessmentResults";
      }
    }

    if (url.hash.startsWith("#/invitation/")) {
      $invitationNumber = url.hash?.split("/").pop();

      console.log("Open invitationNumber", $invitationNumber);
      if ($invitationNumber) {
        const DONE_STATUSES = ["SCORED", "DONE", "SUBMITTED", "ENDED", "CANCEL", "EXPIRED"];
        fetch(`${BASE_URL}/public/assessment/invitation/${$invitationNumber}/definitions-detail`)
          .then(r => r.ok ? r.json() : Promise.reject())
          .then(defs => {
            const allDone = defs.length > 0 && defs.every(d => DONE_STATUSES.includes(d.invDefStatus) || DONE_STATUSES.includes(d.status));
            $currentPage = allDone ? "AssessmentSelection" : "IntroductionPage";
          })
          .catch(() => {
            $currentPage = "IntroductionPage";
          });
      }
    }

    if (url.hash.startsWith("#/invitation-report/")) {
      $invitationNumber = url.hash?.split("/").pop();

      console.log("Open Report invitationNumber", $invitationNumber);
      if ($invitationNumber) {
        //router.goto("/assessment/" + $assessmentId);
        $currentPage = "AssessmentInvitationReport";
      }
    }
  }
</script>

{#key $currentPage || $activationCode}
  {#if $currentPage === "Landing"}
    <InitPage />
  {:else if $currentPage === "AssessmentOverview"}
    <AssessmentOverview instanceId={$instanceId} />
  {:else if $currentPage === "IntroductionPage"}
    <IntroductionPage />
  {:else if $currentPage === "AssessmentExercise"}
    <AssessmentExercise instanceId={$instanceId} exerciseId={$exerciseId} />
  {:else if $currentPage === "AssessmentResults"}
    <AssessmentResults
      instanceId={$instanceId}
      on:resumeAssessment={() => {
        $currentPage = "AssessmentExercise";
        console.log(111);
      }}
    />
  {:else if $currentPage === "AssessmentSelection"}
    <AssessmentSelection />
  {:else if $currentPage === "AssessmentInvitationReport"}
    <AssessmentInvitationReport />
  {:else if $currentPage === "PreviousExam"}
    <PreviousExamPage />
  {:else}
    <!-- <LandingPage104Demo></LandingPage104Demo>   -->
    <!-- <AssessmentSelection /> -->
    {#if $domain === "localhost1" || $domain === "whitelabel.assessment.oksensay.com"}
      <LandingPageWhitelabel />
    {:else if $domain === "liteon.localhost" || $domain.includes("deploy-preview") || $domain === "liteon.assessment.oksensay.com"}
      <LandingPageLiteon />
    {:else if $domain === "localhost2" || $domain === "ntnu.assessment.oksensay.com"}
      <LandingPageNtnu />
    {:else if $domain.startsWith("gjun.")}
      <LandingPageGjun />
    {:else}
      <LandingPageGeneric />
    {/if}
  {/if}
{/key}
<!-- <Route>
  <Route path="/" fallback>Fallback</Route>

  <Route path="/" let:meta>
    <InitPage />
  </Route>

  <Route path="/assessment/:instanceId" let:meta>
    <AssessmentOverview instanceId={meta.params.instanceId} />
  </Route>

  <Route path="/assessment/:instanceId/exercise/:exerciseId" let:meta>
    <AssessmentExercise
      instanceId={meta.params.instanceId}
      exerciseId={meta.params.exerciseId}
    />
  </Route>

  <Route path="/assessment/:instanceId/results" let:meta>
    <AssessmentResults instanceId={meta.params.instanceId} />
  </Route>
</Route> -->
